// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-date-picker__extended[data-v-f4b9bb40] .custom-datetime-picker {\n  position: absolute !important;\n}", ""]);
// Exports
module.exports = exports;
